import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { TabularTypeDataset } from './tabular-type.dataset';
import { IModel } from '../base/annotation';
import { MySqlLinkedService } from '../linkedservice/mysql.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.mysql.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.MySql_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.MySql_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: MySqlLinkedService.MODEL // Linked service redefined
        }
    }
})
export class MysqlTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
